module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_vm._v("Dear Pa,")])]), _c('a', {
    attrs: {
      "id": "prologue"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite all the sadness and hardships of the past, I am ready to forgive and to ask forgiveness, Pa. It has been almost two years since Tom’s death—two years during which not a day has gone by I haven’t missed Tom, and Grandpa, too. But now my time for mourning is over and my time for happiness and love and life is beginning. For I have wonderful news. I’m getting married. To Logan Stonewall, who you may remember was my childhood sweetheart. I’ve been living here in Winnerow, fulfilling my dream of being a teacher just like Miss Marianne Deale, who inspired me so to read and learn and dream and always to believe I could be whatever I wanted to be. It seems all my childhood dreams are finally coming true—all, that is, except my relationship with you. I want you and Drake and Stacie to come to my wedding, Pa. Pa, I would like you to walk down the aisle with me as my father and give me away to my husband. I am so happy, Pa, I want to put away all the bitterness of the past. I want to forgive you, and I want you to forgive me. Maybe now, at this long late date, we can act like a family should. Fanny will be my best lady. I hope you will, at last, be my father.")]), _vm._v(" "), _c('p', {
    staticClass: "right1b"
  }, [_vm._v("Love,")]), _vm._v(" "), _c('p', {
    staticClass: "right1b"
  }, [_vm._v("Heaven")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-caced76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 63
// module chunks = 0